<template>
  <div class="col-xs-12">
    <div class="row row--margin-top">
      <div class="col-xs-1">
        <div
          v-if="carouselActive"
          class="you-may-also-like-carousel__nav-arrow-wrap"
        >
          <span
            :class="prevNavArrowClasses"
            class="fa fa-chevron-left you-may-also-like-carousel__nav-arrow"
            @click="selectedPage--"
          />
        </div>
      </div>
      <div class="col-xs-10">
        <carousel
          :per-page="slidesPerPage"
          :pagination-padding="4"
          :value="selectedPage"
          :pagination-enabled="false"
          pagination-active-color="$grad-color-blue"
          @pageChange="handlePageChange"
        >
          <slide
            v-for="pkg in packages"
            :key="pkg.id"
          >
            <package-detail :offer-package="pkg"/>
          </slide>
        </carousel>
      </div>
      <div class="col-xs-1">
        <div
          v-if="carouselActive"
          class="you-may-also-like-carousel__nav-arrow-wrap"
        >
          <span
            :class="nextNavArrowClasses"
            class="fa fa-chevron-right you-may-also-like-carousel__nav-arrow"
            @click="selectedPage++"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from '@Shared/components/VueCarousel'
import PackageDetail from './PackageDetail'

export default {
  name: 'YouMayAlsoLikePackageCarousel',
  components: {
    Carousel,
    Slide,
    PackageDetail
  },
  props: {
    packages: { type: Array, default: null }
  },
  data () {
    return {
      selectedPage: 0,
      slidesPerPage: 4
    }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.packages.length / this.slidesPerPage) - 1 // zero index-based
    },
    prevNavArrowClasses () {
      return {
        'you-may-also-like-carousel__nav-arrow--disabled':
          this.selectedPage === 0
      }
    },
    nextNavArrowClasses () {
      return {
        'you-may-also-like-carousel__nav-arrow--disabled':
          this.selectedPage === this.totalPages
      }
    },
    carouselActive () {
      return this.packages.length > 4
    }
  },
  watch: {
    selectedPage (v, ov) {
      if (v < 0) {
        this.selectedPage = 0
      } else if (v > this.totalPages) {
        this.selectedPage = this.totalPages
      }
    }
  },
  methods: {
    handlePageChange (page) {
      this.selectedPage = page
    }
  }
}
</script>

<style lang="scss" scoped>
.you-may-also-like-carousel {
  &__nav-arrow {
    color: $grad-color-blue;
    font-size: 32px;
    cursor: pointer;

    &--disabled {
      color: #efefef;
    }

    &-wrap {
      text-align: center;
      margin-top: 180px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/YouMayAlsoLike/PackageCarousel.vue